module.exports = __webpack_public_path__ + "static/scale-model-of-world-peace-bell-center-in-cincinnati-ohio-e9827b84330713caa214c3f8c7aa8f35.png";